/* eslint-disable no-redeclare */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../Generic/Button";
import Card from "../../Generic/Card";
import InputBox from "../../Generic/InputBox";
import SuccessButton from "../../Generic/SuccessButton";
import CookBookConnector from "../Connector/CookBookConnector";
import { postApi, getApi, patchApi } from "../../config/api";
import { successNotification, errorNotification } from "../../Generic/Notifications";
import Dropdown from "../../Generic/Dropdown";
import Checkbox from "../../Generic/Checkbox";
import { RecipeSegmentsEdit } from "./RecipeSegmentsEdit";
import { beautifyKey, CamelCaseToText, diff, flattenObject, isEmpty } from "../../util/util";
import close from "../../Assets/Close.png";
import { CSSTransition } from "react-transition-group";
import { Cross, Tickmark } from "../../Generic/Symbols";
import { Table, Tcol, Thead, Trow } from "../../Generic/Table";
import { SearchBarWithResults } from "./SearchBarWithResults";
import { useNavigate, useParams } from "react-router-dom";
import StudioService from "../Services/StudioService";

const Page = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1rem;
`;

const Div = styled.div`
	height: ${(props) => props.height};
	overflow-y: ${(props) => props.overflowY};
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	gap ${(props) => props.gap};
	@media (max-width: 1000px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 310;
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;
	background: #f2f2f2;
	max-height: 90%;
	height: max-content;
	width: 60vw;
	overflow-x: hidden;
	border-radius: 10px;
	z-index: 305;
`;

const RecipeEdit = (props) => {
	const { objectToEdit } = props;
	const [confirmModal, showConfirmModal] = useState(false);
	//To compare changed recipeSteps
	const navigate = useNavigate();
	const { id } = useParams();

	function updateData(evnt) {
		//Get numeric input for fields if type is set as number
		var payload =
			evnt.target.type == "number"
				? { column: evnt.target.id, value: evnt.target.valueAsNumber }
				: { column: evnt.target.id, value: evnt.target.value };
		if (evnt.target.type === "checkbox") {
			payload = { column: evnt.target.id, value: evnt.target.checked };
		}
		props.updateRecipe(payload);
	}

	async function sendUpdatedData() {
		const response = await StudioService.updateRecipe(id, props.objectToEdit)
		const { data, error } = response;
		if (data) {
			showConfirmModal(false);
			successNotification("Changes saved successfully");
			navigate(`/studio/recipe/${id}`);
		}
		if (error) {
			errorNotification(error);
		}
	}

	function renderRecipeEdit(recipe) {
		return (
			<>
				<Card margin="1rem 0 0 0" width="100%" alignItem="center" flexDirection="column">
					<Div flexWrap="wrap" flexDirection="row" width="100%" alignItem="center" gap="1rem" >
						<Div width="100%" flexDirection="column" jContent="" alignItem="">
							<Div color="rgba(0,0,0,0.6)">Name</Div>
							<Div width="100%" margin="0.5rem 0 0 0">
								<InputBox
									id={"name"}
									onChange={(e) => {
										updateData(e);
									}}
									value={recipe?.name}
									padding="0.5rem"
									width="100%"
								/>
							</Div>
						</Div>
						<Div width="100%" flexDirection="column" jContent="" alignItem="">
							<Div color="rgba(0,0,0,0.6)">Description</Div>
							<Div width="100%" margin="0.5rem 0 0 0">
								<InputBox
									id={"description"}
									onChange={(e) => {
										updateData(e);
									}}
									value={recipe?.description}
									padding="0.5rem"
									width="100%"
								/>
							</Div>
						</Div>
						<Div width="100%" flexDirection="column" jContent="" alignItem="">
							<Div color="rgba(0,0,0,0.6)">Note</Div>
							<Div width="100%" margin="0.5rem 0 0 0">
								<InputBox
									id={"note"}
									onChange={(e) => {
										updateData(e);
									}}
									value={recipe?.note}
									padding="0.5rem"
									width="100%"
								/>
							</Div>
						</Div>
						<Div flexDirection="row" jContent="" alignItem="center">
							<Div flexDirection="column" jContent="" alignItem="">
								<Div color="rgba(0,0,0,0.6)">Preparation Time</Div>
								<Div width="100%" margin="0.5rem 0 0 0">
									<InputBox
										type="number"
										id={"preparationTime"}
										onChange={(e) => {
											updateData(e);
										}}
										value={recipe?.preparationTime}
										padding="0.5rem"
										width="10rem"
									/>
								</Div>
							</Div>
						</Div>
					</Div>
				</Card>
				<RecipeSegmentsEdit segments={recipe?.segments} needMixing={recipe?.needMixing} Patterns={props.Patterns} updatePayload={props.updateRecipe} />
				<Div jContent="flex-end" margin="1rem 0 0 0">
					<Div margin="0.5rem">
						<SuccessButton
							onClick={() => {
								sendUpdatedData();
							}}>
							Confirm
						</SuccessButton>
					</Div>
				</Div>
			</>
		);
	}

	useEffect(() => {
		return () => {
			props.changeEditMode({ editMode: false, objectToEdit: {} })
		}
	}, []);

	return (
		<Page>
			<Div padding="0 0 1rem 0" width="100%" jContent="space-between" alignItem="center">
				<span
					onClick={() => navigate(`/studio/recipe/${id}?action=noReload`)}
					className="material-symbols-outlined"
					style={{ cursor: "pointer" }}>
					arrow_back
				</span>
			</Div>
			{objectToEdit && renderRecipeEdit(objectToEdit)}
			<CSSTransition in={confirmModal} timeout={1000} classNames="container" unmountOnExit>
				<Overlay>
					<Modal>
						<Div
							jContent="space-between"
							alignItem="center"
							color="#fff"
							width="100%"
							background="rgba(45, 35, 66, 0.8)"
							fontSize="1.7rem"
							padding="1rem">
							<Span>Save Changes</Span>
							<img
								onClick={() => {
									showConfirmModal(false);
								}}
								src={close}
								alt="close"
								style={{
									height: "30px",
									filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
							/>
						</Div>
						{/* <Div overflowY="auto" flexDirection="column" padding="0rem 1rem 1rem 1rem">
							{renderChanges()}
						</Div> */}

						<Div jContent="flex-end" margin="1rem 0 0 0">
							<Div
								margin="0.5rem"
								onClick={() => {
									showConfirmModal(false);
								}}>
								<Button>Cancel</Button>
							</Div>
							<Div margin="0.5rem">
								<SuccessButton
									onClick={() => {
										sendUpdatedData();
									}}>
									Confirm
								</SuccessButton>
							</Div>
						</Div>
					</Modal>
				</Overlay>
			</CSSTransition>
		</Page>
	);
};

export default CookBookConnector(RecipeEdit);
